import React from 'react';

type CustomLabelProps = { label: string; sublabel?: string };

function CustomLabel({ label, sublabel }: CustomLabelProps) {
  return (
    <label>
      {label}
      {sublabel && <span style={{ color: 'darkgray', fontWeight: 'normal' }}> - {sublabel}</span>}
    </label>
  );
}

export default CustomLabel;
